import { NgComponentOutlet } from '@angular/common';
import { Component } from '@angular/core';
import { BaseComponent } from '@shared/classes';
import { DynamicComponent, OutOfStockConfig } from '@shared/models';

import { Variant1Component } from './variant1/variant1.component';

@Component({
  selector: 'b2c-outofstock',
  imports: [NgComponentOutlet],
  styleUrl: './outofstock.component.scss',
  templateUrl: './outofstock.component.html',
})
export class OutOfStockComponent extends BaseComponent {
  public config: OutOfStockConfig = this.loyaltyChallengeConfig.components
    .challenges.elements.outOfStock as OutOfStockConfig;

  public components: DynamicComponent<OutOfStockConfig> = {
    [this.Variants.VARIANT_1]: {
      component: Variant1Component,
      inputs: {
        config: this.config,
      },
    },
  };
}
